// extracted by mini-css-extract-plugin
module.exports = {"intro":"NewsSection_intro__VJCjR","title":"NewsSection_title__tYfkJ","list":"NewsSection_list__FpyN2","item":"NewsSection_item__bPm83","ctaBox":"NewsSection_ctaBox__I9PJL"};